import React, { useState, useContext } from 'react';
import { Space, Typography, Alert,  Row, Form, Input, Button } from 'antd';
import { WarningFilled, DeleteOutlined } from '@ant-design/icons';
import { Modal } from '../../UI/Modal/Modal.component';
import { deleteDevice } from '../../../services/StationService';
import { StationContext } from '../../../context/station-context';
import { useNotificationApi } from '../../UI/NotificationProvider';

const { Text, Paragraph, Title } = Typography;

export const DeleteDeviceModal = ({title, item, displayModal, setDisplayModal, ...props}) => {
    
    const notificationApi = useNotificationApi();

    const [state, dispatch ] = useContext(StationContext);
    const [loading, setLoading] = useState(false);

    const handleDelete = () => {
        let entry = {...item ,id: item.id, deleted: true}
        setLoading(true);
        deleteDevice(entry).then ( function ( response ) {
            if( response ) {
                setLoading(false);
                openSuccessNotification();
                dispatch({
                    type: 'DELETE_DEVICE', 
                    payload: item.id,
                })
                props.setVisible ? props.setVisible(false) : setDisplayModal(false);
            }
        })
    };

    const openSuccessNotification = () => {
        notificationApi.success({
            message: 'Device deleted',
            description: `${title} - Serial Number: ${item.serialNum} has been successfully deleted.`,
        });
    };

    const loadingMessage = (
        <Paragraph>
            <strong>Deleting {title}...</strong><br/>
            Please wait, this action may take a few minutes.
        </Paragraph>
    );

    return(
        <>
            <Modal
                icon={<WarningFilled/>}
                color="var(--error-color)"
                title="Delete Device"
                justifyTitle="middle"
                visible={props.visible || displayModal}
                setVisible={props.setVisible || setDisplayModal}
                actionGroup={false}
                loading={loading}
                loadingMessage={loadingMessage}
                width={420}
            >
                <Alert
                    message= {<Text strong style={{color: "var(--error-color)"}}>{title} <br/> Serial Number: {item.serialNum} </Text>}
                    type="error"
                    closable={false}
                    style={{marginBottom: 15, textAlign: 'center'}}
                />
                
                <Paragraph>All data from this device will be permanently removed and you won't be able to undo this action.</Paragraph>
                <Paragraph>Please type <strong>"DELETE"</strong> to confirm: </Paragraph>
            
                <Form
                    name='deleteDeviceForm'
                    autoComplete='off'
                    layout='vertical'
                    preserve={false}
                    onFinish={() => {handleDelete()}}
                    >
                    <Form.Item 
                        name='delete'
                        rules={[
                            {
                                required: true,
                                validateTrigger: 'onSubmit',
                                validator: (_, value) => {
                                        if(value === 'DELETE'){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Please enter "DELETE" if you want to proceed.'));
                                    }
                                }
                            ]}
                        >
                        <Input style={{textAlign: 'center', }} onInput={(e) => e.target.value = e.target.value.toUpperCase()}/>
                    </Form.Item>
                    <Row justify='end'>   
                        <Form.Item noStyle>
                            <Space>
                                <Button onClick={() => props.setVisible ? props.setVisible(false) : setDisplayModal(false)}>Cancel</Button>
                                <Button htmlType='submit' type='primary' danger icon={<DeleteOutlined/>}>Yes, delete device</Button>
                            </Space>
                        </Form.Item>
                    </Row>
                </Form>
            </Modal>     
        </>
    )
};